export const BUILD_INFO = {
  "app": "lottotracker",
  "version": "ede149704c9b-1793807720531",
  "gitSha": "ede149704c9b5b4a7d379021023d1560c965e59b",
  "builtAt": "2026-11-04T15:55:20.531Z"
};
export default BUILD_INFO;
